import React, { Component } from 'react';
import './App.css'
import RouterContainer from './router-container';

class App extends Component {
    render() {
        return (
            <div>
                <RouterContainer />
            </div>
        );
    }
}

export default App;